/*
 * @Author: lsh lsh@163.com
 * @Date: 2022-05-17 13:27:59
 * @LastEditors: lsh lsh@163.com
 * @LastEditTime: 2022-06-29 17:02:50
 * @FilePath: /xhj/src/utils/request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
const instance = axios.create({
  baseURL: " https://yxy.medsky.cn/api/",
  // baseURL: 'http://yixinyuan.cc/api/',
  timeout: 10000,
});
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    //console.log('全局', config)
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    const res = response.data;
    return res;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default instance;
